export default __webpack_public_path__ + "static/media/bg_left.483bf953.png";